import React from 'react'
import { usePermissions } from '../../hooks/usePermissions'
import { canAccessFeature, canWriteFeature, type FeatureKey } from '../../lib/permissions'

interface PermissionGateProps {
  feature?: FeatureKey
  requireWrite?: boolean
  requireAdmin?: boolean
  fallback?: React.ReactNode
  children: React.ReactNode
}

export const PermissionGate: React.FC<PermissionGateProps> = ({
  feature,
  requireWrite = false,
  requireAdmin = false,
  fallback = null,
  children,
}) => {
  const permissions = usePermissions()

  if (permissions.isLoading) return null

  if (requireAdmin && !permissions.isPlatformAdmin) {
    return <>{fallback}</>
  }

  if (feature) {
    if (requireWrite) {
      if (!canWriteFeature(permissions, feature)) return <>{fallback}</>
    } else {
      if (!canAccessFeature(permissions, feature)) return <>{fallback}</>
    }
  }

  return <>{children}</>
}
